import { InsightsReportOrganizationService, PaginatedDTO_CohortInsightsReportDTO_ } from '@om1/falcon-api'
import { handleApiError } from '@om1/falcon-api/utils'
import { rwaConditionsActions } from '@om1/platform-settings-module/src/state/rwa-conditions'
import { rwaInsightsReportActions } from '@om1/platform-settings-module/src/state/rwa-insights-reports'
import { call, put } from 'redux-saga/effects'
import { insightsLibraryActions } from '../state/insights-library'

export function createGetInsightsLbraryReportsSaga() {
    return function* (action: ReturnType<typeof insightsLibraryActions.getInsightsLibraryReports>) {
        try {
            yield put(insightsLibraryActions.setCohortInsightsLibraryReportsLoading({ loading: true }))
            yield put(rwaConditionsActions.getRwaConditions({ path: {}, query: {} }))
            yield put(rwaInsightsReportActions.getRwaInsightsReports())
            const paginatedInsightsReports: PaginatedDTO_CohortInsightsReportDTO_ = yield call(
                InsightsReportOrganizationService.indexRwaInsightsInsightsReportOrganizationGet,
                {
                    cohortId: undefined,
                    insightsReportId: undefined,
                    page: 1,
                    limit: 1000
                }
            )
            yield put(insightsLibraryActions.setCohortInsightsLibraryReports({ cohortInsightsReports: paginatedInsightsReports.data }))
        } catch (error) {
            yield handleApiError(error)
        } finally {
            yield put(insightsLibraryActions.setCohortInsightsLibraryReportsLoading({ loading: false }))
        }
    }
}
